<template>
  <div class="index" v-show='list'>
    <div class="headerimg">
      <img src="../../static/image/header.png" alt="">
    </div>
    <!-- <div class="swbox">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, i) in banner" :name="item.name" :key="item.id">
          <a :href="item.url"><img class="bannerimg" :src="item.banner" alt=""></a>
        </van-swipe-item>
      </van-swipe>
    </div> -->
    <div class="stbox">
      <img src="../../static/image/dingimg.png" alt="">
      <van-collapse v-model="activeNames">
        <van-collapse-item disabled class="collapseItem" v-for="(i, ind) in list" :name="ind" :key="ind"
          v-if="i.title=='指数篇'">
          <div class="jianbian"></div>
          <div class="list">
            <p v-for="(j, index) in i.list" v-show="true" :key="index" @click="goDetails(j.id)">
              <img src="../../static/image/qs.png" class="qsimg" alt="">{{ j.title }}
            </p>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <!-- <van-search background="#fff" placeholder="请输入搜索关键词" @click="goSearch('')" /> -->

    <div class="bottomText">
      基金有风险，投资须谨慎
    </div>
    <!-- <tab></tab> -->
  </div>
</template>

<script>
import { catalogList2 } from "@/api/index";

import tab from "@/components/tab";
export default {
  name: "index1",
  components: { tab },
  data () {
    return {
      activeNames: [0, 1, 2, 3, 4, 5, 6],
      list: [],
      banner: []
    };
  },
  created () {
    this.getList();
  },
  methods: {
    getList () {
      catalogList2()
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            let list = res.data.list;
            list.forEach((i) => {
              i.showAll = false;
            });
            this.banner = res.data.banner
            console.log(this.banner)
            this.list = list;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    goDetails (id) {
      this.$router.push({
        path: "/newdetail",
        query: {
          id: id,
        },
      });
    },
    goSearch (item) {
      this.$router.push({
        path: "/search",
        query: {
          msg: item,
        },
      });
    },
  },
};
</script>
<style lang="less">
.index {
  // min-height: 82vh;
  margin: 0;
  display: inline-block;
  width: 100%;
  padding-bottom: 7.5rem;
  position: relative;
  background: url("../../static/image/bgimg.png");
  background-size: 100% 100%;
  .headerimg {
    margin: 0 auto;
    height: 160px;
    width: 375px;
    img {
      width: 100%;
    }
  }
  h5 {
    margin: 0.625rem 0;
  }
  .van-search {
    padding: 0.625rem 0;
    margin-bottom: 0.6rem;
  }
  .van-search__content {
    padding-left: 0;
  }
  .van-search .van-cell {
    line-height: 2rem;
    background: #f4f4f4;
    border-radius: 3.125rem;
    padding: 0 0.625rem;
    box-sizing: border-box;
  }
  .van-cell--clickable {
    background: #fff;
  }
  .collapseItem {
    position: relative;
    box-sizing: border-box;
    width: 94%;
    margin-left: 3%;
    margin-top: -3rem;
    margin-bottom: 1.2rem;
    border-radius: 0.875rem;
    overflow: hidden;
    // box-shadow: 0rem 0.125rem 0.75rem 0rem rgba(0, 0, 0, 0.12);
    box-shadow: 6px 6px 30px 0px #fee9d0;
    .cricl {
      display: inline-block;
      width: 1.25rem;
      height: 1.25rem;
      line-height: 1.25rem;
      margin-right: 0.625rem;
      background-image: linear-gradient(to bottom, #1830ff, #79adff);
      border-radius: 50%;
      font-style: normal;
      text-align: center;
      color: #fff;
      font-weight: 600;
    }
    .showA {
      background: #fff;
      width: 6.25rem;
      height: 1.875rem;
      position: absolute;
      right: 0;
      z-index: 10;
      text-align: right;
      padding-right: 0.625rem;
      line-height: 2.1875rem;
    }
    .list {
      color: #333;
      p {
        padding: 0.3125rem 0;
        border-bottom: 0.0625rem solid #d8d8d8;
        &:last-child {
          border-bottom: 0;
        }
      }
    }
  }
  .bottomText {
    position: absolute;
    width: 100%;
    text-align: center;
    // bottom: 3.8rem;
    font-size: 0.75rem;
    color: #999;
  }
  .van-collapse-item__title {
    display: none;
  }
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
}
.bannerimg {
  width: 355px;
}
.swbox {
  width: 355px;
  height: 100px;
  margin: 0 auto;
}
.qsimg {
  width: 15px !important;
  vertical-align: -0.15em;
  margin-right: 0.5em;
}
.stbox {
  position: relative;
  width: 365px;
  margin: 0 auto;
  img {
    width: 100%;
  }
}
.jianbian {
  position: absolute;
  left: -1px;
  top: -1px;
  width: 100%;
  height: 14px;
  background: linear-gradient(to bottom, #fa842eff, rgb(250, 250, 249));
}
.van-collapse {
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 0 !important;
}
.van-hairline--top-bottom::after {
  border: 0 !important;
}
.van-hairline--top-bottom {
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/newindex.vue